import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { InfluencerPostDetailsModal } from '@anytag/shared-molecules';
import { InfluencerSocialPost, SocialPostType } from '@anytag/graphql';
import { useInfluencerScrapingPostsListTable } from './hooks';

export interface InfluencerScrapingPostsListProps extends TableData<InfluencerSocialPost> {
  influencerId?: number;
  socialPostType: SocialPostType;
}

export const InfluencerScrapingPostsList = ({
  loading,
  data = [],
  influencerId,
  socialPostType
}: InfluencerScrapingPostsListProps) => {
  const { columns } = useInfluencerScrapingPostsListTable({ socialPostType });

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} rowHeight="62px" noTopBorderRadius hasBorder />

      <InfluencerPostDetailsModal posts={data.map(({ id }) => ({ id: String(id), influencerId }))} />
    </>
  );
};
